// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__qfGqJ","background":"Modal_background__lSzre","inner":"Modal_inner__N1lvd"};